<template>
    <div>
        <router-view name="captableModal"></router-view>
        <v-card flat>
            <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>

            <template v-else>
                <v-container>
                    <!-- companyInfo -->
                    <company-info :client="client"></company-info>
                    <!-- companyInfo -->

                    <v-divider></v-divider>

                    <current-captable :client="client" @refresh-all="refreshHistoric"></current-captable>

                    <!-- historyCaptable -->
                    <history-captable class="mt-4" :client="client" :refresh-historic.sync="refreshHistoricFlag"></history-captable>
                    <!-- historyCaptable -->
                </v-container>
            </template>
        </v-card>
    </div>
</template>

<script>
import API from '@/api'
import CompanyInfo from '@/components/corporate/CompanyInfo'
import CurrentCaptable from '@/components/corporate/CurrentCaptable'
import HistoryCaptable from '@/components/corporate/HistoryCaptable'

export default {
    name: 'inner-tab-corporate-captable',
    components: {
        CompanyInfo,
        CurrentCaptable,
        HistoryCaptable
    },
    data: function () {
        return {
            loading: true,
            client: {
                name: '',
                optingSimple: false,
                commercialPhone: '',
                stateRegistrationIndicator: '',
                stateRegistration: '',
                municipalRegistration: '',
                city: '',
                cellPhone: '',
                cep: '',
                neighborhood: '',
                totalUsers: undefined,
                isActive: true,
                socialReason: '',
                state: '',
                comments: '',
                address: '',
                country: '',
                addressComplement: '',
                primaryEmail: '',
                type: '',
                addressNumber: '',
                suframaSubscription: '',
                rg: '',
                birthdayFoundationDate: '',
                cpfcnpj: '',
                password: '',
                clientContact: {},
                clientUser: {},
                companyInfo: {}
            },
            refreshHistoricFlag: false
        }
    },
    watch: {
        '$route': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        }
    },
    mounted () {
        this.loadData()
        window.addEventListener('storageChange', this.onStorageChange)
    },
    beforeDestroy () {
        window.removeEventListener('storageChange', this.onStorageChange)
    },
    methods: {
        onStorageChange () {
            this.loadData()
        },
        loadData () {
            this.loading = true
            window.getApp.disableClientNavigation = true
            let endpoint = API.EndPoints.getClientCorporateInfo
            let params = {
                objectId: this.$helpers.getCorporateClientId(this.$route.name, 'ClienteSocietarioCaptable', this.$route.params.id)
            }
            new API(endpoint, params).request().then(response => {
                this.client = Object.assign({}, response.data.result)
                if (!this.client.companyInfo) {
                    this.client.companyInfo = {
                        socialReason: '',
                        companyType: 1,
                        socialObjects: '',
                        CNAES: '',
                        headquarters: '',
                        meetingDate: ''
                    }
                }
                if (!this.client.shareCapital) {
                    this.client.shareCapital = null
                }
                this.loading = false
                window.getApp.disableClientNavigation = false
            }, (e) => {
                this.$helpers.requestError(e)
            })
        },
        refreshHistoric () {
            this.loadData()
            this.refreshHistoricFlag = true
        }
    }
}
</script>
